import LoadingView from 'components/Elements/LoadingView'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import Footer from './Footer'
import Topbar from './Topbar'
import { PageLayoutContainer } from './style'

const PageLayout = ({ children }) => {
  const { isLoading } = useContext(DataContext)
  const { pathname } = useLocation()

  const isIndependent = () => {
    const independentPaths = [
      'register',
      'forgot-password',
      'forgotpasswordverification',
    ]

    for (const path of independentPaths) {
      if (pathname.includes(path)) return true
    }
    return false
  }

  return (
    <PageLayoutContainer>
      {!isIndependent() && <Topbar />}
      <div className="page-content">{children}</div>
      {!isIndependent() && <Footer />}
      <LoadingView isLoading={isLoading} />
    </PageLayoutContainer>
  )
}

export default PageLayout
